import { Link } from "@tanstack/react-router";
import { Scale } from "lucide-react";

interface LogoProps {
  className?: string;
  asLink?: boolean;
  /** Color variant. 'dark' for light backgrounds, 'light' for dark backgrounds. */
  variant?: "dark" | "light";
}

export function Logo({ className = "", asLink = true, variant = "dark" }: LogoProps) {
  const textColor = variant === "light" ? "text-white" : "text-[#1B3A6B]";
  const iconColor = variant === "light" ? "text-white" : "text-[#1B3A6B]";

  const content = (
    <span className={`flex items-center gap-2 ${className}`}>
      <Scale className={`h-7 w-7 ${iconColor}`} strokeWidth={2.25} />
      <span className={`text-lg font-bold tracking-tight ${textColor}`}>legaldecoder</span>
    </span>
  );

  if (!asLink) return content;

  return (
    <Link to="/" className="group inline-flex items-center" aria-label="legaldecoder home">
      {content}
    </Link>
  );
}
